import React, { Fragment, useContext, useState } from "react";
import { Button } from "@mui/material";
import { FiPlus } from "react-icons/fi";
import SwitchField from "../../../components/editable/EditableField/fields/SwitchField";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import { api, DeviceConfig, IListDeviceConfigsRequest } from "../../../logic/api";
import flex from "../../../styles/flex";
import DeviceConfigDialog from "./DeviceConfigDialog";
import DeviceConfigListItem from "./components/listItems/DeviceConfigListItem";
import { DeviceActivationDialog } from "../device_activation/DeviceActivationDialog";
import { useTranslation } from "react-i18next";
import ConfirmationDialog from "../../../components/notifications/confirmationDialog/ConfirmationDialog";
import { SessionContext } from "../../../utility/useSession";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";

const DeviceConfigList = () => {

  const [listParams, setListParams] = useState<IListDeviceConfigsRequest>({
    includeInactive: false,
    paging: {
      offset: 0,
      limit: 0,
    }
  });
  const [showDialog, setDialogShow] = useState(false);
  const [selectedConfig, setSelectedConfig] = useState<DeviceConfig | undefined>(undefined);

  const [showDeviceActivationDialog, setShowDeviceActiviationDialog] = useState(false);
  const [showDeleteConfig, setShowDeleteConfig] = useState(false);
  const { t } = useTranslation();

  const deleteDeviceConfigAPI = api.hooks.deviceManager.deleteConfig();
  const session = useContext(SessionContext);

  const deleteConfig = () => {
    if (selectedConfig?.id != null) {
      setShowDeleteConfig(false);
      deleteDeviceConfigAPI.send(session.current.context, { id: selectedConfig.id }, () => {
        setListParams({ ...listParams });
        setSelectedConfig(undefined);
      });
    }
  }

  return <div>

    <ConfirmationDialog
      title={t("overview.confirmDelete")}
      message={t("lists.confirmMobileConfigDelete", { name: selectedConfig?.name ?? "" })}
      show={showDeleteConfig}
      onClose={(confirm) => {
        setShowDeleteConfig(false);
        if (confirm == true) {
          deleteConfig();
        }
      }}
    />
    <ErrorDialog err={deleteDeviceConfigAPI.err} />
    <DeviceActivationDialog show={showDeviceActivationDialog} deviceConfig={selectedConfig} onCompleted={(didActivateNewDevice) => {
      setShowDeviceActiviationDialog(false);
      if (didActivateNewDevice) {
        setListParams({ ...listParams });
      }
    }} />
    <DeviceConfigDialog show={showDialog} deviceConfigId={selectedConfig?.id} onClose={(didUpdate) => {
      setDialogShow(false);
      if (didUpdate) {
        setListParams({ ...listParams });
      }
    }} />
    <div style={{ padding: 10, textAlign: "right" }}>
      <div style={flex.flexRows}>
        <Fragment>
          <div style={flex.flexAuto}>
            <SwitchField
              onChange={(includeInactive) => {
                setListParams({
                  ...listParams,
                  includeInactive: includeInactive,
                });
              }}
              value={listParams.includeInactive}
            />
          </div>
          <div style={flex.flexAuto}>
            <div
              style={{ textAlign: "right", paddingTop: 10, color: "grey" }}
            >
              {t("mobile.includeDisabled")}
            </div>
          </div>
        </Fragment>

        <div style={flex.flexFill} />

        <div style={flex.flexAuto}>
          <Button
            style={{ marginLeft: 10 }}
            variant="contained"
            color="secondary"
            onClick={() => {
              setSelectedConfig(undefined);
              setDialogShow(true);
            }}
          >
            <FiPlus style={{ marginRight: 10 }} /> {t("mobile.newConfig")}
          </Button>
        </div>

      </div>
    </div>
    <PagedDataView<IListDeviceConfigsRequest, DeviceConfig>
      apiHook={api.hooks.deviceManager.listConfigs}
      parameters={listParams}
      renderItem={(item) => {
        return <DeviceConfigListItem
          key={item.id}
          deviceConfig={item}
          onEditConfig={() => {
            setSelectedConfig(item);
            setDialogShow(true);
          }}
          onRequestActivation={() => {
            setSelectedConfig(item);
            setShowDeviceActiviationDialog(true);
          }}
          onDeleteConfig={item.active ? () => {
            setSelectedConfig(item);
            setShowDeleteConfig(true);
          } : undefined}
        />
      }}
    >
      <div style={{ padding: 20, backgroundColor: "#eee" }}>
        {t("mobile.noConfigs")}
      </div>
    </PagedDataView>
  </div>;
}
export default DeviceConfigList;
